<template>
  <section style="display: flex; flex-direction: column; align-items: start; padding-bottom: 1.5rem;">
    <TablePager class="mt-2" v-model="pageIndex" @previous="PagingPrevious" @next="PagingNext" @to="LoadPage"
    :totalPages="totalPages" />
    <small class="d-block d-flex justify-content-center">{{ itemsCount }}</small>
  </section>
</template>
<script>
import TablePager from '../../../../components/forms/TablePager.vue'

export default {
  name: 'AssociatePagination',
  data () {
    return {
      totalPages: 0,
      pageIndex: 0,
      pageLimit: 10,
      currentPage: 0,
      totalElements: 0,
      numberOfElementsDisplayed: 0,
      offset: 0
    }
  },
  components: {
    TablePager
  },
  computed: {
    itemsCount () {
      return `Exibindo ${this.offset} a ${this.offset + this.numberOfElementsDisplayed} de ${this.totalElements} registros`
    }
  },
  methods: {
    ActivePage (index) {
      if (index === this.currentPage) {
        return 'disabled'
      } else {
        return ''
      }
    },
    ActivePrevious: function () {
      if (this.pageIndex <= 0) {
        return 'disabled'
      } else {
        return ''
      }
    },
    ActiveNext: function () {
      if ((this.currentPage + 1) >= this.totalPages) {
        return 'disabled'
      } else {
        return ''
      }
    },
    PagingNext () {
      var index = this.pageIndex + 1
      if (this.currentPage < this.totalPages) {
        this.pageIndex = index
        this.currentPage = this.currentPage + 1
        this.LoadPage(index + 1)
      }
    },
    PagingPrevious () {
      var index = this.pageIndex - 1
      if (this.currentPage > 0) {
        this.pageIndex = index
        this.currentPage = this.currentPage - 1
        this.LoadPage(index + 1)
      }
    },
    LoadPage (index) {
      this.currentPage = index
      this.pageIndex = index - 1
      if (this.currentPage >= 0 && this.currentPage <= this.totalPages) {
        this.$emit('LoadPage', this.pageIndex)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/pagination/associatepagination.vue